import { Snapsnap } from '@photocreate/snapsnap-api'
import { APIRequest } from '@/infra/network/APIRequest'
import { HTTPMethod } from '@/infra/network/types'

/**
 * クレジット決済ステータス取得API
 */
export class GetCreditPaymentStatus implements APIRequest<Snapsnap.Credit.GetFincodeTransactionStatusResponse> {
  response: Snapsnap.Credit.GetFincodeTransactionStatusResponse
  path: string
  method = HTTPMethod.GET

  constructor(fincodeOrderId: string) {
    this.path = `/credit/${encodeURIComponent(fincodeOrderId)}/transaction/status`
  }
}
